import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LastUpdatedInformationComponent } from './last-updated-information.component';

@NgModule({
  imports: [CommonModule],
  declarations: [
    LastUpdatedInformationComponent
  ],
  exports: [
    LastUpdatedInformationComponent
  ],
})
export class LastUpdatedInformationModule {}
